/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }

  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  new Swiper('.sp-swiper-fade', {
    autoplay: {
      disableOnInteraction: false,
      delay: 3500,
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
  })

  new Swiper('.sp-swiper-scroll-top', {
    spaceBetween: 160,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    speed: 8000,
    slidesPerView: 'auto',
  })
  new Swiper('.sp-swiper-scroll-top-m', {
    spaceBetween: 250,
    loop: true,
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    speed: 10000,
    slidesPerView: 'auto',
  })

  // new Swiper(".sp-swiper2", {
  //     autoplay: {
  //         delay: 3500,
  //         disableOnInteraction: false,
  //         reverseDirection: false,
  //     },
  //     slideShadows: true,
  //     slidesPerView: "auto",
  //     spaceBetween: 0,
  //     centeredSlides: true,
  //     loop: true,
  //     pagination: {
  //         el: ".sp-pagination",
  //         clickable: true,
  //     },
  //     navigation: {
  //         nextEl: ".sp-swiper-btn-next",
  //         prevEl: ".sp-swiper-btn-prev",
  //     },
  // });

  // Part3 对比轮播
  new Swiper('.sp3-compare-swiper', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: '.sp3-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.sp3-next',
      prevEl: '.sp3-prev',
    },
  })

  new Swiper('.sp-swiper3-m', {
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    pagination: {
      el: '.sp-swiper3-m-pagination',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,

    pagination: {
      el: '.sp-pagination1',
      clickable: true,
    },
  })

  new Swiper('.sp-swiper1-mobile', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,
    pagination: {
      el: '.sp-pagination1-m',
      clickable: true,
    },
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 50,
  })

  // sp-part1-media 长图滚动轮播（支持手动滑动）
  new Swiper('.sp-media-swiper', {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 12000,
    spaceBetween: 0,
    loop: true,
    slidesPerView: 'auto',
    freeMode: true,
    grabCursor: true,
  })

  // sp-part5 颜色选项轮播（移动端）- 走马灯效果
  new Swiper('.sp5-color-swiper', {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 3000,
    spaceBetween: 30,
    loop: true,
    slidesPerView: 'auto',
    freeMode: true,
    allowTouchMove: true,
    grabCursor: true,
  })

  // 移动端 guarantee-tags 轮播 - 走马灯效果（仅移动端）
  if (document.body.clientWidth <= 1080) {
    new Swiper('.sp-guarantee-swiper', {
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      speed: 4000,
      spaceBetween: 40,
      loop: true,
      loopAdditionalSlides: 3,
      slidesPerView: 'auto',
      freeMode: {
        enabled: true,
        momentum: false,
      },
      allowTouchMove: false,
      grabCursor: false,
    })
  }

  // 移动端 sp-part2 问题卡片轮播
  new Swiper('.sp2-problems-swiper', {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    spaceBetween: 30,
    loop: true,
    slidesPerView: 'auto',
    freeMode: true,
    allowTouchMove: true,
    grabCursor: true,
  })

  // sp-part5 底部图片走马灯
  new Swiper('.sp5-gallery-swiper', {
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 5000,
    spaceBetween: 20,
    loop: true,
    slidesPerView: 'auto',
    freeMode: true,
    allowTouchMove: true,
    grabCursor: true,
  })

  let prods = window.product
  function getCur() {
    let opt1 = $('#sp-color div.active').attr('data-val')
    let opt2 = $('#sp-set div.active').attr('data-val')
    return prods.filter(item => item.option1 == opt1)[0]
  }
  function changePrice() {
    let num = $('#calcNumber').val()
    let price = ((getCur().price * num) / 100).toFixed(2)
    let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    console.log(price)
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    let off_font =
      100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
    $('.sp_product_part .sp-price-group .off-font').html(off_font)
  }

  // 价格配置: { color: { set: [现价, 原价] } }
  var priceConfig = {
    Blue: {
      only: [9.99, 23.99],
      armband: [12.99, 29.99],
      bundle: [19.99, 49.99],
    },
    Pink: {
      only: [9.99, 23.99],
      armband: [12.99, 29.99],
      bundle: [19.99, 49.99],
    },
    Yellow: {
      only: [9.99, 23.99],
      armband: [12.99, 29.99],
      bundle: [19.99, 49.99],
    },
    Green: {
      only: [9.99, 23.99],
      armband: [12.99, 29.99],
      bundle: [19.99, 49.99],
    },
  }

  // 图片索引映射: { color: { set: index } }
  // p1-p4: 单绳, p5-p8: +手环, p9-p12: 买2送3
  var imageIndexMap = {
    Blue: { only: 0, armband: 4, bundle: 8 },
    Pink: { only: 1, armband: 5, bundle: 9 },
    Yellow: { only: 2, armband: 6, bundle: 10 },
    Green: { only: 3, armband: 7, bundle: 11 },
  }

  // 更新图片和价格
  function updateProductDisplay() {
    // var color = $('#sp-color .sp-option.active').data('color');
    // var set = $('#sp-set .sp-option.active').data('set');
    let colorIndex = $('#sp-color .sp-option.active').index()
    let setIndex = $('#sp-set .sp-option.active').index()
    let imgIndex = colorIndex + setIndex * 4
    var num = Number($('#calcNumber').val()) || 1

    // 切换图片
    // var imgIndex = imageIndexMap[color][set];
    _swiper.slideTo(colorIndex)

    // 更新价格
    // var prices = priceConfig[color][set];
    // sp_price1 = prices[0];
    // sp_price2 = prices[1];
    // $('#sp_price1').html(calcTotal(sp_price1, num));
    // $('#sp_price2').html(calcTotal(sp_price2, num));
  }

  // 选项点击事件
  $('#sp-color .sp-option, #sp-model .sp-option, #sp-set .sp-option').click(
    function () {
      $(this).siblings().removeClass('active')
      $(this).addClass('active')
      updateProductDisplay()
      changePrice()
    }
  )

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // preloadImages();

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop

        let sptop = document.body.clientWidth <= 1080 ? -310 : -180

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }

    // Part7 轮播
    new Swiper('.sp-swiper2', {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        reverseDirection: false,
      },
      slideShadows: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: '.sp-pagination',
        clickable: true,
      },
    })

    // Part1 底部特性走马灯
    new Swiper('.sp-bottom-features-swiper', {
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      speed: 3000,
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: true,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      grabCursor: false,
      allowTouchMove: false,
    })
  }

  mainRender()

  var sp_price1 = 19.99
  var sp_price2 = 39.99

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }

  $('.sp-btn-style').click(function () {
    let num = $('#calcNumber').val()
    window.location.href = '/cart/' + getCur().id + ':' + num
  })
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  let spTimer = null
  let spHasShown = false // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 滚动添加底部
    if (spHasShown) return // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 1000) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = true // 标记为已显示
      }, 1000)
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  let initNum = 0
  $(document).on('click', '.sp_add_cart', function () {
    // 购物车加购动效

    $(this).children('img').addClass('on')
    $('.sp-cart .num').show()
    setTimeout(function () {
      $(' .cart-btn').children('img').removeClass('on')
    }, 500)
    $(' .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-cart').removeClass('on')
    }, 500)

    let spNum = $('.sp_product_part #calcNumber')[0].value
    initNum += Number(spNum)

    // $("#calcNumber").val(1);

    var data = {
      id: getCur().id,
      quantity: $('#calcNumber').val(),
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + 'cart.js', function (result) {
          // $("#cardNum").html(result.item_count);
          $('.cardNum').each(function () {
            $(this).html(result.item_count)
            $(this).removeClass('sp-gray')
          })
        })
      },
      dataType: 'json',
    })

    var imgs = $('.sp_product_part .swiper-slide-active').find('img')
    // var imgs = $(".sp_product_part .sp-img-p.active");

    imgs.each(function () {
      var $img = $(this)
      var flyer = $img[0].cloneNode(true)
      flyer.classList.add('sp_clone')

      $('.sp_product_part').append(flyer)
      $(flyer).css({
        width: $img[0].width,
        height: $img[0].height,
        background: '#e7e9ef',
        position: 'fixed',

        top: $img[0].offsetTop,
        left: $img.offset().left,
        'z-index': 99,
      })
      let finish
      if (document.body.clientWidth <= 1080) {
        finish = $('.sp-mobile-sticky-cart')

        $(flyer).animate(
          {
            top: finish.offset().top,
            left: finish.offset().left + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          2000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      } else {
        finish = $('.sp_pc .sp-cart')
        $(flyer).animate(
          {
            top: finish[0].offsetTop,
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach()
              }
            )
          }
        )
      }
    })
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // 统一处理所有 #shopping 链接的跳转
  document.querySelectorAll('a[href="#shopping"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault()
      var target = document.getElementById('shopping')
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    })
  })

  // sp-part5 特性切换轮播 (Swiper) - PC端
  var sp5Swiper = new Swiper('.sp_pc .sp5-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    direction: 'horizontal',
    speed: 500,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp_pc .sp5-pagination',
      clickable: true,
    },
  })

  // sp-part5 特性切换轮播 (Swiper) - 移动端
  var sp5SwiperM = new Swiper('.sp_mobile .sp5-swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    direction: 'horizontal',
    speed: 500,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    pagination: {
      el: '.sp_mobile .sp5-pagination',
      clickable: true,
    },
  })
})

// QA3 展开/收起功能
$('.sp-qa3-question').on('click', function () {
  var $currentItem = $(this).closest('.sp-qa3-item')
  var $answer = $currentItem.find('.sp-qa3-answer')

  if ($currentItem.hasClass('active')) {
    $answer.slideUp(300)
    $currentItem.removeClass('active')
  } else {
    $('.sp-qa3-item').removeClass('active')
    $('.sp-qa3-answer').slideUp(300)
    $currentItem.addClass('active')
    $answer.slideDown(300)
  }
})

// QA2 展开/收起功能
$('.sp-qa2-question').on('click', function () {
  var $currentItem = $(this).closest('.sp-qa2-item')
  var $answer = $currentItem.find('.sp-qa2-answer')

  if ($currentItem.hasClass('active')) {
    $answer.slideUp(300)
    $currentItem.removeClass('active')
  } else {
    $('.sp-qa2-item').removeClass('active')
    $('.sp-qa2-answer').slideUp(300)
    $currentItem.addClass('active')
    $answer.slideDown(300)
  }
})
